import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=09586bd2&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=ts"
export * from "./UserAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09586bd2",
  null
  
)

export default component.exports